function ensureThreeDaysFromNow(startDate) {
  // Parse the refDate string into a Date object
  let date = new Date(startDate);

  // Get the current date
  let now = new Date();

  // Calculate the difference in milliseconds
  let diff = date.getTime() - now.getTime();

  // Convert the difference to days
  let diffDays = diff / (1000 * 60 * 60 * 24);

  // If the difference is less than three days
  if (diffDays < 3) {
    // Calculate how many days we need to add
    let daysToAdd = 3 - Math.floor(diffDays);

    // Add the necessary days
    date.setDate(date.getDate() + daysToAdd);
  }

  // Return the possibly adjusted date
  return date;
}

class HPDatePicker {
  constructor() {
    const today = new Date();
    const sixWeeksAhead = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 14); //42
    this.pickerOptions = {
      // Event callbacks.
      onSelect: (instance) => {
        // Show which date was selected.
        console.log('instance', instance);
        if (!instance.dateSelected) return;
        ModalDatePicker.onSelect(instance.dateSelected);
      },
      onShow: (instance) => {
        // console.log('Calendar showing.')
      },
      onHide: (instance) => {
        // console.log('Calendar hidden.')
      },
      onMonthChange: (instance) => {
        // Show the month of the selected date.
        console.log(instance.currentMonthName);
      },

      // Customizations.
      formatter: (input, date, instance) => {
        input.value = formateDateforUI(date);
        ModalDatePicker.onFormat(date);
      },
      position: 'bl', // Top right.
      startDay: 1, // Calendar week starts on a Monday.
      customDays: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
      customMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      // customOverlayMonths: ['😀', '😂', '😎', '😍', '🤩', '😜', '😬', '😳', '🤪', '🤓 ', '😝', '😮'],
      // overlayButton: 'Go!',
      overlayPlaceholder: 'Enter a 4-digit year',
      onShow: (instance) => {
        // Do stuff when the calendar is shown.
        // You have access to the datepicker instance for convenience.
        // console.log('Calendar showing.', instance);
        instance.el.style.visibility = 'hidden';
      },
      // Settings.
      alwaysShow: true, // hide the calendar.
      // dateSelected: window.refDate, // Today is selected.
      maxDate: sixWeeksAhead, // Jan 1st, 2099.
      // minDate: window.refDate,
      startDate: today, // This month.
      showAllDates: 0, // Numbers for leading & trailing days outside the current month will show.

      // Disabling things.
      noWeekends: false, // Saturday's and Sunday's will be selectable.
      disabler: this.disablerForOneDaysDelivery, // Disable every Sunday
      disabledDates: window.hp_disabledDates, // Specific disabled dates.
      disableMobile: false, // Conditionally disabled on mobile devices.
      disableYearOverlay: false, // Clicking the year or month will *not* bring up the year overlay.

      // ID - be sure to provide a 2nd picker with the same id to create a daterange pair.
      id: 1,
    };
  }

  init(postalCode) {
    window.refDate = new Date(window.refDateOrig);
    this.postcodeRule = window.getPostcodeRule(postalCode);
    window.disabledDaysForSelectedPostcode = this.postcodeRule ? this.postcodeRule.disabledDays : [];
    const isTwoDayPostCode = this.postcodeRule ? this.postcodeRule.is2day : false;
    window.DeliveryDayMargin = isTwoDayPostCode ? 2 : 1;

    this.nextAvailableDayForTwoDaysDelivery = () => {
      window.refDate = ensureThreeDaysFromNow(window.refDateOrig2day);
      return new Date(
        [0, 1, 2, 3, 4, 5, 6]
          .filter((day) => this.postcodeRule?.disabledDays?.indexOf(day) == -1)
          .map((day) => this.getNextDayOfWeek(window.refDate, day).getTime())
          .sort()[0],
      );
    };

    this.pickerOptions.disabler = this.customDisabler.bind(this);
    this.pickerOptions.minDate = DeliveryDayMargin === 1 ? window.refDate : this.nextAvailableDayForTwoDaysDelivery();

    if (this.pickerOptions.minDate < this.pickerOptions.maxDate && window.deliveryDateWhitelistApplied) {
      const today = new Date();
      const oneYearAhead = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate());
      this.pickerOptions.maxDate = oneYearAhead;
    }

    this.pickerOptions.startDate = DeliveryDayMargin === 1 ? window.refDate : this.nextAvailableDayForTwoDaysDelivery();
    this.pickerOptions.disabledDates = window.hp_disabledDates;

    let startDate = this.pickerOptions.startDate;
    while (this.isDateDisabled(startDate)) {
      startDate.setDate(startDate.getDate() + 1);
    }
    this.pickerOptions.startDate = startDate;

    if (this.picker) this.picker.remove();

    this.picker = datepicker('#date-picker-js', this.pickerOptions);
    window.deliveryDatePicker = this.picker;
  }

  isDateDisabled(date) {
    return this.pickerOptions.disabledDates.some((disabledDate) => {
      return (
        date.getDate() === disabledDate.getDate() &&
        date.getMonth() === disabledDate.getMonth() &&
        date.getFullYear() === disabledDate.getFullYear()
      );
    });
  }

  customDisabler(date) {
    var day = date.getDay();
    return (
      window.disabledDaysForSelectedPostcode.indexOf(day) > -1 || window.postCodesExcludedWeekDays.indexOf(day) > -1
    );
  }

  getNextDayOfWeek(date, dayOfWeek) {
    var resultDate = new Date(date.getTime());
    resultDate.setDate(date.getDate() + ((7 + dayOfWeek - date.getDay()) % 7));
    return resultDate;
  }

  // getDisabledDatesForChristmas(startDate, endDate) {
  //   let disabledDates = [];

  //   const today = new Date();

  //   let currentDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  //   while (currentDate < startDate) {
  //     disabledDates.push(new Date(currentDate));
  //     currentDate.setDate(currentDate.getDate() + 1);
  //   }

  //   currentDate = new Date(endDate.getTime() + 24 * 60 * 60 * 1000);
  //   while (currentDate.getFullYear() < 2099) {
  //     disabledDates.push(new Date(currentDate));
  //     currentDate.setDate(currentDate.getDate() + 1);
  //   }

  //   return disabledDates;
  // }
}
